import { AxiosError } from 'axios';
import { DEBOUNCE_TIME } from 'data/global';

export const MAX_RETRY_COUNT = 1;

export const getMaxRetryCount = (config?: Record<string, any>) =>
  (config && config.__maxRetryCount) ?? MAX_RETRY_COUNT;

const RETRYABLE_CODES = [
  'ECONNRESET',
  'ENOTFOUND',
  'ECONNREFUSED',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
];

export const isRetryableError = (error: AxiosError) => {
  const noResponse = !error.response;

  const codeRetryable = error.code && RETRYABLE_CODES.includes(error.code);

  return noResponse || codeRetryable;
};

export const delay = (retry: number, ms = DEBOUNCE_TIME) =>
  new Promise((resolve) => setTimeout(resolve, ms * retry));
